/**
 * Validate a clinic CCN (CMS Certification Number), which prefills OASIS M0010.
 *
 * Mirrors the OASIS live-scrubber rules for M0010_CCN so a malformed CCN is
 * caught on the clinic form instead of silently prefilling M0010 and only
 * failing the scrubber at SOC export:
 *   - -3120 (fatal): alphanumeric only — [A-Za-z0-9]
 *   - -5280 (fatal): exactly 6 characters, or blank
 *
 * Blank is allowed (M0010 permits a blank value). Intentionally NOT numeric-only:
 * the CCN system uses a letter in position 3 for some facility types.
 *
 * Returns an error message, or null if valid.
 */
export function validateCcn(ccn: string): string | null {
  const trimmed = ccn.trim();

  if (trimmed === '') {
    return null;
  }

  if (!/^[A-Za-z0-9]{6}$/.test(trimmed)) {
    return 'CCN must be exactly 6 letters or digits';
  }

  return null;
}
